// Maximum quantity per variant
const maxQuantity = 5;

// Function to check and update cart item quantities
function checkCartLimits() {
  // Fetch the current cart
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let overLimit = false;
      cart.items.forEach(item => {
        if (item.quantity > maxQuantity) {
          overLimit = true;
          // Update the quantity to the max allowed
          updateCartItemQuantity(item.id, maxQuantity);
        }
      });

      if (overLimit) {
        alert(`You can only add a maximum of ${maxQuantity} of each variant to your cart.`);
      }
    });
}

// Function to update the cart item quantity
function updateCartItemQuantity(itemId, quantity) {
  fetch(`/cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: { [itemId]: quantity } }),
  }).then(() => {
    // Refresh the cart
    window.location.reload();
  });
}

// Trigger the check when the cart is updated
document.addEventListener('cart:updated', checkCartLimits);

// Also trigger the check when the page loads
document.addEventListener('DOMContentLoaded', checkCartLimits);
